import React, { Component } from "react";
import "./style.scss";
import {
  updateForm,
  getSelectedTreatmentList,
} from "redux/actions/appointment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  commonCreateApi,
  commonPatchApi,
  commonDeleteApi,
  commonUpdateApi,
} from "redux/actions/common";
import {
  NormalSelect,
  NormalButton,
  NormalModal,
  NormalInput,
  NormalDateTime,
  NormalCheckbox,
  NormalTimePicker,
  NormalDate,
  TableWrapper,
  NormalTextarea,
} from "component/common";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import closeIcon from "assets/images/close.png";
import { dateFormat } from "service/helperFunctions";
import { Toast } from "service/toast";
export class StudioATreatmentClass extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
  }
  state = {
    selectedList: [
      {
        appt_id: "",
        appointmentDate: new Date(),
        start_time: new Date(),
        end_time: "",
        Item_Codeid: null,
        add_duration: "",
        emp_no: 0,
        requesttherapist: false,
        Item_CodeName: "",
        edit_remark: "",
        recur_days: null,
        recur_qty: null,
        item_text: null,
        checktype: "",
        treat_parentcode: null,
        bookingStatus: "",
        new_remark: "",
        edit_remark: "",
      },
    ],
    formFields: {
      customerName: "",
      emp_id: "",
      appointmentDate: new Date(),
      bookingStatus: "",
      Source_Codeid: "",
      ItemSite_Codeid: "",
      new_remark: "",
      Appt_typeid: "",
      // emp_noid : 4,
      Room_Codeid: "",
      sec_status: "",
      bookedby: "",
      editedby: "",
      walkin: false,
      remark_setting: false,
      edit_remark: "",
      cart_create: false,
      cust_StoreCard: false,
      cust_refer: "",

      maxclasssize: 0,
      isOpenParticipants: false,
      participantName: "",
      editParticipantId: "",
      editParticipantStatus: "Booked",
      editParticipantRemarks: "",
      editParticipantStatusList: [
        { value: "Booked", label: "Booked" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Arrived", label: "Arrived" },
        { value: "Done", label: "Done" },
      ],

      chkMaxClass: false,
    },
    appointmentId: null,
    settingData: {},
    isOpenModal: false,
    categoryList: [],
    treatmentField: {
      category: "",
      treatment: "",
    },
    selectTreatmentId: "",
    treatmentListHeader: [
      { label: "Category", className: "w-50" },
      { label: "Service", className: "w-75" },
      {
        label: "Duration",
        className: "w-25",
        divClass: "justify-content-end text-right",
      },
      {
        label: "price",
        className: "w-50",
        divClass: "justify-content-end text-right",
      },
    ],
    meta: {},
    treatmentList: [],
    duration: [],
    staffOption: [],
    bookingList: [],
    DeletedList: [],
    freeTextStockId: "",
    search: "",
  };

  componentDidMount() {
    let { categoryList, duration, staffOption } = this.state;
    this.search({});
    console.log(this.props.apptId, "apptId");
    if (this.props.apptId) {
      this.getAppointmentData();
    }
    this.handleItemSettings();
    this.props.getCommonApi("bookingstatus/").then((res) => {
      let { status, data, sec_data } = res;

      if (status === 200) {
        this.setState({ bookingList: data, secStatusList: sec_data });
      }
    });
    this.props.getCommonApi(`itemdept/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          categoryList.push({ value: value.id, label: value.itm_desc });
        }
        this.setState({ categoryList });
      }
    });
    this.props.getCommonApi(`treatment/Duration/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          duration.push({ value: value, label: value });
        }
        this.setState({ duration });
      }
    });
    const siteId = this.props.tokenDetail.logined_siteid;
    let date;

    date = new Date();
    date.setHours(0, 0, 0, 0);

    this.props
      .getCommonApi(
        `appointment/Staffs/?Outlet=${siteId}&date=${dateFormat(
          new Date(date)
        )}`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          for (let value of data) {
            staffOption.push({ value: value.id, label: value.emp_name });
          }
          this.setState({ staffOption });
        }
      });
    // this.getFreetextStockid();
  }
  getAppointmentData = async () => {
    let { formFields } = this.state;
    this.props
      .getCommonApi(
        `appointmentedit/${this.props.apptId}/?site_select=${this.props.tokenDetail.logined_siteid}`
      )
      .then((res) => {
        const appointmentData = res.data;
        const selectedList = appointmentData.treatment
          .filter((treatmentItem) => treatmentItem.appt_status !== "Cancelled")
          .map((treatmentItem) => ({
            appt_id: treatmentItem.appt_id,
            appointmentDate: new Date(treatmentItem.appt_date),
            start_time: new Date(`2000-01-01 ${treatmentItem.start_time}`),
            end_time: treatmentItem.end_time,
            Item_Codeid: treatmentItem.item_id,
            add_duration: treatmentItem.add_duration,
            emp_no: treatmentItem.emp_id,
            requesttherapist: treatmentItem.requesttherapist,
            Item_CodeName: treatmentItem.item_text,
            recur_days: treatmentItem.recur_days,
            recur_qty: treatmentItem.recur_qty,
            item_text: treatmentItem.item_text,
            checktype: treatmentItem.checktype,
            treat_parentcode: treatmentItem.treat_parentcode,
            bookingStatus: treatmentItem.appt_status,
            new_remark: treatmentItem.new_remark,
          }));
        this.props.updateForm("customerDetail", formFields);
        this.props.updateForm("treatmentList", selectedList);
        this.setState({ selectedList });
      });
  };
  search = (data) => {
    let { page = 1, limit = 10, search = "" } = data;
    let { selectTreatmentId, freeTextStockId } = this.state;
    this.props
      .getCommonApi(
        `stocklist/?Item_Deptid=${selectTreatmentId}&search=${search}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        console.log(res, "treatmentList treatment_parentcode");
        if (res.status === 200) {
          this.setState({
            treatmentList: res.data.dataList,
            meta: res.data.meta.pagination,
          });
          if (res.data && res.data.stock_id && res.data.stock_id !== " ") {
            this.setState({ freeTextStockId: res.data.stock_id });
          } else {
            Toast({
              type: "error",
              message: "Stock Id not found for free text item",
            });
          }
        }
      });
  };
  handleDialog = () => {
    this.setState({ isOpenModal: false, index: null });
  };
  handleDateChange = async ({ target: { value, name } }, index) => {
    let { formFields, selectedList } = this.state;
    console.log(selectedList[index], "selectIndex");
    if (selectedList[index].hasOwnProperty(name)) {
      selectedList[index][name] = value;
    } else {
      formFields[name] = value;
    }

    await this.setState({
      formFields,
      selectedList,
    });
    this.props.updateForm("customerDetail", formFields);
    await this.props.updateForm("appointmentCustomerDetail", formFields);
    if (name === "ItemSite_Codeid") {
      let { staffList } = this.state;
      // Added by Santhosh (this.props.siteId)
      this.props
        .getCommonApi(`appointment/Staffs/?Outlet=${this.props.siteId}`)
        .then((key) => {
          let { status, data } = key;
          if (status === 200) {
            for (let value of data) {
              staffList.push({ value: value.id, label: value.emp_name });
            }
            this.setState({ staffList });
          }
        });
    }

    if (name === "isWalkin") {
      // let { formFields } = this.state;
      // formFields["customerName"] = "";
      // formFields["custName"] = "";
      // formFields["cust_refer"] = "";
      // this.setState({ formFields });
      this.setState((prevState) => ({
        isWalkin: !prevState.isWalkin,
      }));
    }
    if (name == "bookingStatus" && String(value).toUpperCase() == "CANCELLED") {
      let { formFields } = this.state;
      formFields["sec_status"] = "Rescheduled";
      this.setState({
        formFields,
      });
    }

    if (name == "chkMaxClass" && value == true) {
      this.handleSearchForDefaultCustomer("class"); //Yoonus
      let { formFields } = this.state;
      formFields["maxclasssize"] = 1; //Yoonus
      this.setState({
        formFields,
      });
    }
    if (name == "maxclasssize") {
      if (value.length >= 4) {
        let { formFields } = this.state;
        formFields["maxclasssize"] = value.slice(0, -1);
        this.setState({
          formFields,
        });
      }
    }

    if (name == "chkMaxClass" && value == false) {
      //this.handleSearchForDefaultCustomer("");

      let { formFields } = this.state;
      formFields["customerName"] = "";
      formFields["custName"] = "";
      formFields["maxclasssize"] = 0;
      this.setState({
        formFields,
      });
    }
  };
  handleDatePick = async ({ target: { value, name } }, index) => {
    let { selectedList, appointmentId } = this.state;
    let time = this.getHoursFromDate(value);
    let duration = "";
    if (selectedList[index]["add_duration"] !== "") {
      duration = selectedList[index]["add_duration"];
    } else {
      duration = "00:00";
    }
    selectedList[index]["start_time"] = value
      ? value
      : this.timeToDateFormat(selectedList[index]["start_time"]);
    if (time) {
      selectedList[index]["end_time"] = this.addTimes(time, duration);
    }
    if (selectedList.length - 1 > index) {
      let endTime = "";
      if (appointmentId) {
        endTime = this.timeToDateFormat(selectedList[index]["end_time"]);
      } else {
        endTime = selectedList[index]["end_time"];
      }
      selectedList[index + 1]["start_time"] = endTime;
      if (selectedList[index + 1]["add_duration"] !== "") {
        selectedList[index + 1]["end_time"] = this.addTimes(
          selectedList[index]["end_time"],
          selectedList[index + 1]["add_duration"]
        );
      }
    }
    console.log(selectedList, "selectedList");
    await this.setState({
      selectedList,
    });
    await this.props.updateForm("treatmentList", selectedList);
  };
  handleSelectTreatment = async (data) => {
    let { selectedList, index, appointmentId } = this.state;
    console.log(data, "eventsData");
    if (index == 0 && selectedList.length == 1) {
      selectedList[0]["start_time"] = selectedList[0]["start_time"];
      // if (appointmentId) {
      selectedList[0]["end_time"] = this.addTimes(
        this.getHoursFromDate(selectedList[0]["start_time"]),
        data.add_duration ? data.add_duration : "00:00"
      );
      // } else {
      //   selectedList[0]["end_time"] = this.addTimes(
      //     selectedList[0]["start_time"],
      //     data.add_duration ? data.add_duration : "00:00"
      //   );
      // }
      selectedList[0]["Item_Codeid"] = data.id;
      selectedList[0]["Item_CodeName"] = data.item_desc;
      selectedList[0]["item_text"] = data.item_desc;
      selectedList[0]["add_duration"] = data.add_duration;
      selectedList[0]["checktype"] = "service";
      selectedList[0]["treat_parentcode"] = null;

      await this.setState({
        selectedList,
      });
      await this.props.updateForm("treatmentList", selectedList);
    } else {
      selectedList[index]["start_time"] = selectedList[index]["start_time"];
      // if (appointmentId) {
      selectedList[index]["end_time"] = this.addTimes(
        this.getHoursFromDate(selectedList[index]["start_time"]),
        data.add_duration ? data.add_duration : "00:00"
      );
      // } else {
      //   selectedList[index]["end_time"] = this.addTimes(
      //     selectedList[index]["start_time"],
      //     data.add_duration ? data.add_duration : "00:00"
      //   );
      // }
      selectedList[index]["Item_Codeid"] = data.id;
      selectedList[index]["Item_CodeName"] = data.item_desc;
      selectedList[index]["item_text"] = data.item_desc;
      selectedList[index]["add_duration"] = data.add_duration;
      selectedList[index]["checktype"] = "service";
      selectedList[index]["treat_parentcode"] = null;

      let endTime = "";
      //if (appointmentId) {
      endTime = this.timeToDateFormat(selectedList[index]["end_time"]);
      // } else {
      //   endTime = selectedList[index]["end_time"];
      // }
      if (selectedList.length - 1 > index) {
        selectedList[index + 1]["start_time"] = endTime;
        if (selectedList[index + 1]["add_duration"] !== "") {
          selectedList[index + 1]["end_time"] = this.addTimes(
            selectedList[index]["end_time"],
            selectedList[index + 1]["add_duration"]
          );
        }
      }
      await this.setState({
        selectedList,
      });
      await this.props.updateForm("treatmentList", selectedList);
    }
    this.setState({ isOpenModal: false });
  };

  getHoursFromDate = (date) => {
    let hour = date.getHours();
    let minute = date.getMinutes();
    let hours = hour > 9 ? hour : "0" + hour;
    let minutes = minute > 9 ? minute : "0" + minute;
    return hours + ":" + minutes;
  };
  addTimes = (t0, t1) => {
    return this.timeFromMins(this.timeToMins(t0) + this.timeToMins(t1));
  };
  timeToMins = (time) => {
    var b = time.split(":");
    return b[0] * 60 + +b[1];
  };
  timeFromMins = (mins) => {
    function z(n) {
      return (n < 10 ? "0" : "") + n;
    }
    var h = ((mins / 60) | 0) % 24;
    var m = mins % 60;
    return z(h) + ":" + z(m);
  };
  handleTimePick = async (event) => {
    let value = event.target.value;
    console.log(value, "value");
    let { selectedList } = this.state;
    debugger;
    let time = this.getHoursFromDate(value);
    selectedList[0]["start_time"] = time;
    // if (time) {
    //   selectedList[0]["end_time"] = time;
    // }
    // let duration = "0:0";
    // if (selectedList[0].duration !== "" && selectedList[0].duration !== null) {
    //   duration = selectedList[0].duration;
    // }
    // if (selectedList[0].end_time !== "") {
    //   selectedList[0]["end_time"] = this.addTimes(time, duration);
    // }
    console.log(selectedList, "selectedListCheck");
    await this.setState({
      selectedList,
    });
  };
  handleItemSettings = () => {
    let { settingData } = this.state;
    this.props.getCommonApi(`userlist/`).then((key) => {
      let { status, data } = key;
      console.log(key, "settingsData appointmentCreate");
      if (status === 200) {
        settingData = data;
        this.setState({ settingData });
      }
    });
  };
  // getFreetextStockid = (async) => {
  //   let { treatmentField, search, selectTreatmentId } = this.state;
  //   let page = 1,
  //     limit = 10;
  //   this.props
  //     .getCommonApi(
  //       `stocklist/?Item_Deptid=${selectTreatmentId}&search=${search}&page=${page}&limit=${limit}`
  //     )
  //     .then((res) => {
  //       console.log(res, "stocklistfreetextresponse");
  //       let { data, status } = res;
  //       if (status === 200) {
  //         if (data && data.stock_id && data.stock_id !== " ") {
  //           this.setState({ freeTextStockId: data.stock_id });
  //         } else {
  //           Toast({
  //             type: "error",
  //             message: "Stock Id not found for free text item",
  //           });
  //         }
  //       }
  //     });
  // };
  handleSearch = async (event) => {
    event.persist();
    let { treatmentField } = this.state;
    treatmentField["treatment"] = event.target.value || "";
    debugger;
    await this.setState({ search: event.target.value, treatmentField });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async (event) => {
        let searchString = event.target.value;
        let data = { search: searchString };
        // this.queryHandler(data)
        this.search(data);
      }, 500);
    }
    this.debouncedFn(event);
  };
  handleChangeTreatment = async ({ target: { value, name } }) => {
    let { treatmentField, search, selectTreatmentId } = this.state;
    console.log("uihwkjrwkej", name, value);
    treatmentField[name] = value;
    if (name === "category") {
      selectTreatmentId = value;
    } else if (name === "treatment") {
      search = value;
    }
    await this.setState({
      treatmentField,
      selectTreatmentId,
      search,
    });

    let page = 1,
      limit = 10;
    this.props
      .getCommonApi(
        `stocklist/?Item_Deptid=${selectTreatmentId}&search=${search}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        console.log(res, "stocklis");
        if (res.status === 200) {
          this.setState({
            treatmentList: res.data.dataList,
            meta: res.data.meta.pagination,
          });
        }
      });
  };
  handleChange = async ({ target: { value, name } }, index) => {
    let { selectedList, appointmentId, freeTextStockId } = this.state;

    if (name === "add_duration") {
      //if (appointmentId) {
      selectedList[index]["end_time"] = this.addTimes(
        this.getHoursFromDate(selectedList[index]["start_time"]),
        value ? value : "00:00"
      );
      // } else {
      //   selectedList[index]["end_time"] = this.addTimes(
      //     selectedList[index]["start_time"],
      //     value ? value : "00:00"
      //   );
      // }
      selectedList[index]["add_duration"] = value;
      if (selectedList.length - 1 > index) {
        let endTime = "";
        //if (appointmentId) {
        endTime = this.timeToDateFormat(selectedList[index]["end_time"]);
        // } else {
        //   endTime = selectedList[index]["end_time"];
        // }
        selectedList[index + 1]["start_time"] = endTime;
        if (selectedList[index + 1]["add_duration"] !== "") {
          selectedList[index + 1]["end_time"] = this.addTimes(
            selectedList[index]["end_time"],
            selectedList[index + 1]["add_duration"]
          );
        }
      }
    } else if (name === "Item_CodeName") {
      selectedList[index]["Item_Codeid"] = freeTextStockId;
      selectedList[index]["Item_CodeName"] = value;
      selectedList[index]["item_text"] = value;
      selectedList[index]["checktype"] = "freetext";
      selectedList[index]["treat_parentcode"] = null;
    } else if (name === "recur_days" || name === "recur_qty") {
      if (value <= 0 || value === "") {
        selectedList[index][name] = null;
      } else {
        selectedList[index][name] = Number(value);
      }
    } else {
      selectedList[index][name] = value;
    }

    await this.setState({
      selectedList,
    });
    await this.props.updateForm("treatmentList", selectedList);
  };
  timeToDateFormat = (TimeValue) => {
    let time = String(TimeValue).split(":");
    let newTime = new Date(new Date().setHours(time[0], time[1], 0, 0));
    return newTime;
  };
  handleAddtreatment = async (index) => {
    let { selectedList, formFields, appointmentId } = this.state;
    console.log(selectedList, "selectListTest");
    if (selectedList[index]["end_time"]) {
      let start = "";
      //if (appointmentId) {
      start = this.timeToDateFormat(
        selectedList[selectedList.length - 1].end_time
      );
      // } else {
      //   start = selectedList[selectedList.length - 1].end_time;
      // }
      formFields = {
        appt_id: null,
        start_time: start,
        appointmentDate: new Date(),
        end_time: "",
        Item_Codeid: this.state.freeTextStockId,
        add_duration: "",
        emp_no: 0,
        requesttherapist: false,
        recur_days: null,
        recur_qty: null,
        item_text: null,
        checktype: "",
        treat_parentcode: null,
      };
      selectedList.push({
        appt_id: null,
        appointmentDate: new Date(),
        bookingStatus: "",
        new_remark: "",
        start_time: start,
        end_time: "",
        Item_Codeid: this.state.freeTextStockId,
        Item_CodeName: "",
        add_duration: "",
        emp_no: 0,
        requesttherapist: false,
        recur_days: null,
        recur_qty: null,
        item_text: null,
        checktype: "",
        treat_parentcode: null,
      });

      await this.setState({ selectedList, formFields });

      await this.props.updateForm("treatmentList", selectedList);
    } else {
      Toast({ type: "error", message: "End time shouldn't be empty" });
    }
  };
  deleteTreatment = async (index, item) => {
    debugger;
    let { selectedList, DeletedList } = this.state;
    selectedList.splice(index, 1);
    DeletedList.push(item.appt_id);
    this.setState({ selectedList, DeletedList });
    await this.props.updateForm("treatmentList", selectedList);
  };
  stafflistvalidation = (appointmentTreatmentList) => {
    if (appointmentTreatmentList.length > 0) {
      for (let item of appointmentTreatmentList) {
        if (!item.emp_no || item.emp_no === "" || item.emp_no === null) {
          Toast({ type: "error", message: "Please select Staff" });
          return false;
        } else {
          return true;
        }
      }
    }
  };
  handleSubmit = async () => {
    try {
      let {
        appointmentCustomerDetail,
        appointmentTreatmentList,
        customerId,
        tokenDetail,
      } = this.props;
      console.log(appointmentTreatmentList, "appointmentTreatment");
      console.log(appointmentCustomerDetail, "appointmentCustomerDetail");
      let { dragpassword, dragusername, DeletedList } = this.state;
      console.log(
        appointmentCustomerDetail,
        "appointmentcustomerdetailwhenSave"
      );
      console.log(
        appointmentTreatmentList,
        "savedappointmentTreatmentListWhenSave"
      );
      let finalPostAppointment = {};
      let finalPostTreatment = [];
      let finalPutAppointment = {};
      let finalPutTreatment = [];
      finalPostAppointment = {
        appt_date: dateFormat(
          new Date(appointmentTreatmentList[0].appointmentDate),
          "yyyy-mm-dd"
        ),

        cust_noid: customerId,
        new_remark: appointmentTreatmentList[0].new_remark,
        appt_status: appointmentTreatmentList[0].bookingStatus,
        sec_status: "",
        ItemSite_Codeid: tokenDetail.logined_siteid,
      };
      finalPutAppointment = {
        appt_date: dateFormat(
          new Date(appointmentTreatmentList[0].appointmentDate),
          "yyyy-mm-dd"
        ),
        cust_noid: customerId,
        new_remark: appointmentTreatmentList[0].new_remark,
        Room_Codeid: 0,
        appt_status: appointmentTreatmentList[0].bookingStatus,
        sec_status: "",
        source_id: 0,
        ItemSite_Codeid: tokenDetail.logined_siteid,
        channel_id: 0,
        apptdel_id: DeletedList,
      };

      for (let TreatmentList of appointmentTreatmentList) {
        finalPostTreatment.push({
          appt_date: dateFormat(
            new Date(TreatmentList.appointmentDate),
            "yyyy-mm-dd"
          ),
          appt_id: TreatmentList.appt_id,
          appt_status: TreatmentList.bookingStatus,
          start_time: this.getHoursFromDate(TreatmentList.start_time),
          end_time: TreatmentList.end_time,
          add_duration: TreatmentList.add_duration,
          Item_Codeid: TreatmentList.Item_Codeid,
          item_text: TreatmentList.item_text,
          emp_no: Number(TreatmentList.emp_no),
          requesttherapist: TreatmentList.requesttherapist,
          recur_qty: TreatmentList.recur_qty,
          recur_days: TreatmentList.recur_days,
          checktype: TreatmentList.checktype,
          treat_parentcode: TreatmentList.treat_parentcode,
          new_remark: TreatmentList.new_remark,
          appt_isactive: 0,
          reason: this.props.cartId,
          cartid: this.props.cartId,
        });
      }
      for (let TreatmentList of appointmentTreatmentList) {
        finalPutTreatment.push({
          appt_date: dateFormat(
            new Date(TreatmentList.appointmentDate),
            "yyyy-mm-dd"
          ),
          appt_id: TreatmentList.appt_id,
          appt_status: TreatmentList.bookingStatus,
          start_time: this.getHoursFromDate(TreatmentList.start_time),
          end_time: TreatmentList.end_time,
          add_duration: TreatmentList.add_duration,
          item_id: TreatmentList.Item_Codeid,
          item_text: TreatmentList.item_text,
          emp_id: Number(TreatmentList.emp_no),
          requesttherapist: TreatmentList.requesttherapist,
          recur_qty: TreatmentList.recur_qty,
          recur_days: TreatmentList.recur_days,
          checktype: TreatmentList.checktype,
          treat_parentcode: TreatmentList.treat_parentcode,
          new_remark: TreatmentList.new_remark,
          appt_isactive: 0,
          reason: this.props.cartId,
          cartid: this.props.cartId,
        });
      }

      if (this.stafflistvalidation(appointmentTreatmentList)) {
        let postData = {
          Appointment: finalPostAppointment,
          Treatment: finalPostTreatment,
        };
        let putData = {
          appointment: finalPutAppointment,
          treatment: finalPutTreatment,
        };
        if (this.props.apptId) {
          this.props
            .commonPatchApi(`appointmentedit/${this.props.apptId}/`, putData)
            .then((res) => {
              this.props.handleCloseDialog();
              this.props.handleOpenPayment();
            });
        } else {
          this.props
            .commonCreateApi(`appointment/`, postData)
            .then(async (res) => {
              this.props.handleCloseDialog();
              this.props.handleOpenPayment();
            });
        }
      }
    } catch (e) {
      console.log("appointment catch log", e);
    }
  };
  render() {
    let {
      formFields,
      selectedList,
      appointmentId,
      settingData,
      isOpenModal,
      categoryList,
      treatmentField,
      treatmentListHeader,
      meta,
      treatmentList,
      duration,
      staffOption,
      bookingList,
    } = this.state;
    let { t } = this.props;
    return (
      <div className="form-group mb-4 pb-2 appointment-form">
        <div className="d-flex">
          <div className="d-flex justify-content-start col-md-11 col-12 h5 p-0">
            {t("Create Appointment")}
          </div>

          <div className="d-flex justify-content-end align-items-center bg-white cursor-pointer col-md-1 col-12">
            <img
              src={closeIcon}
              alt="AppointmentForm"
              className="close"
              onClick={this.props.handleCloseDialog}
            />
          </div>
        </div>
        <div className="create-appointment select-treatment-appointment overflowTable">
          <div className="row col-12 col-sm-12 co-md-12 col-lg-12 col-xl-12">
            <div className="appointment">
              <div className="appointment-holder">
                <div className="treatment-section p-0">
                  <div className="select-treatment select-list w-100">
                    <div className="table-container studio-date-picker mt-3">
                      <div className="d-flex selected selected-header  mb-4 w-100 overflow-auto">
                        <div className="col-2  mr-1  p-0">{t("Date")}</div>
                        <div className="col-1  mr-1  p-0">
                          {t("Start Time")}
                        </div>
                        {/* <div className="col-1 p-0">{t("Start")}</div> */}
                        <div className="col-1  mr-1  p-0">{t("End Time")}</div>
                        <div className="col-2  mr-1  p-0 header-detail">
                          {t("Service")}
                        </div>

                        <div className="col-1  mr-1  p-0 header-detail">
                          {t("Duration")}
                        </div>
                        <div className="col-1  mr-1  p-0">
                          {t("Treatment Staff")}
                        </div>
                        <div className="col-1  mr-1  p-0 header-detail">
                          {t("Booking Status")}
                        </div>
                        <div className="col-2 p-0">{t("Remarks")}</div>
                      </div>
                      {selectedList.length > 0 ? (
                        selectedList.map((item, index) => {
                          return (
                            <div className="d-flex selected  mb-4" key={index}>
                              <div className="col-2  mr-1 ">
                                <NormalDate
                                  value={new Date(item.appointmentDate)}
                                  name="appointmentDate"
                                  type="date"
                                  onChange={(e) =>
                                    this.handleDateChange(e, index)
                                  }
                                  minDate={new Date()}
                                  showDisabledMonthNavigation
                                />
                              </div>
                              <div className="col-1 mr-1 p-0">
                                <NormalTimePicker
                                  className={`cursor-pointer`}
                                  onChange={(e) =>
                                    this.handleDatePick(e, index)
                                  }
                                  label="start_time"
                                  name="start_time"
                                  timeOnly={true}
                                  dateFormat={`HH:mm`}
                                  showTime={true}
                                  selected={false}
                                  placeholder=""
                                  timeIntervals={5}
                                  value={item.start_time}
                                  showIcon={false}
                                />
                              </div>
                              {/* <div className="col-1 mr-1 p-0">
                                <NormalInput
                                  label="startTime"
                                  name="startTime"
                                  value={item.start_time}
                                  className="customer-name p-0"
                                  disabled
                                  placeholder="start"
                                />
                              </div> */}
                              <div className="col-1  mr-1   p-0">
                                <NormalInput
                                  placeholder="end"
                                  // options={timeDropdown}
                                  value={item.end_time}
                                  name="end_time"
                                  onChange={() => {}}
                                  className="customer-name p-0"
                                  disabled={true}
                                />
                              </div>
                              <div className="col-2  mr-1  p-0">
                                <div className="header-detail"></div>
                                {settingData &&
                                settingData.service_sel &&
                                settingData.service_text ? (
                                  <NormalInput
                                    placeholder="service"
                                    // options={siteList}
                                    value={item.Item_CodeName}
                                    name="Item_CodeName"
                                    onDoubleClick={() =>
                                      this.setState({
                                        isOpenModal: true,
                                        index: index,
                                      })
                                    }
                                    onChange={(e) =>
                                      this.handleChange(e, index)
                                    }
                                    className="customer-name p-0 px-2"
                                  />
                                ) : null}
                                {settingData &&
                                settingData.service_sel &&
                                !settingData.service_text ? (
                                  <NormalInput
                                    placeholder="service"
                                    // options={siteList}
                                    value={item.Item_CodeName}
                                    name="Item_CodeName"
                                    onDoubleClick={() =>
                                      this.setState({
                                        isOpenModal: true,
                                        index: index,
                                      })
                                    }
                                    onChange={() => {}}
                                    className="customer-name p-0 px-2"
                                  />
                                ) : null}
                                {settingData &&
                                !settingData.service_sel &&
                                settingData.service_text ? (
                                  <NormalInput
                                    placeholder="service"
                                    // options={siteList}
                                    value={item.Item_CodeName}
                                    name="Item_CodeName"
                                    onClick={() => {}}
                                    onChange={(e) =>
                                      this.handleChange(e, index)
                                    }
                                    className="customer-name p-0 px-2"
                                  />
                                ) : null}
                                {settingData &&
                                !settingData.service_sel &&
                                !settingData.service_text ? (
                                  <NormalInput
                                    placeholder="service"
                                    // options={siteList}
                                    value={item.Item_CodeName}
                                    name="Item_CodeName"
                                    onClick={() => {}}
                                    onChange={() => {}}
                                    className="customer-name p-0 px-2"
                                  />
                                ) : null}
                              </div>
                              <div className="col-1 mr-1 p-0 header-detail">
                                <NormalSelect
                                  // placeholder="Enter here"
                                  options={duration}
                                  value={item.add_duration}
                                  name="add_duration"
                                  onChange={(e) => this.handleChange(e, index)}
                                  className="customer-name p-0"
                                />
                              </div>
                              <div className="col-1  mr-1 p-0">
                                <NormalSelect
                                  // placeholder="Enter here"
                                  options={staffOption}
                                  value={item.emp_no}
                                  name="emp_no"
                                  onChange={(e) => this.handleChange(e, index)}
                                  className="customer-name p-0"
                                />
                              </div>
                              <div className="col-1  mr-1  p-0 ">
                                <NormalSelect
                                  options={bookingList}
                                  value={item.bookingStatus}
                                  name="bookingStatus"
                                  onChange={(e) =>
                                    this.handleDateChange(e, index)
                                  }
                                  className="customer-name  py-1"
                                />
                              </div>
                              <div className="col-2 p-0 ">
                                {formFields.remark_setting ? (
                                  <NormalTextarea
                                    // placeholder="Enter here"
                                    // options={siteList}
                                    value={item.new_remark}
                                    name="new_remark"
                                    onChange={(e) =>
                                      this.handleDateChange(e, index)
                                    }
                                    disabled
                                  />
                                ) : (
                                  <NormalTextarea
                                    // placeholder="Enter here"
                                    // options={siteList}
                                    value={item.new_remark}
                                    name="new_remark"
                                    onChange={(e) =>
                                      this.handleDateChange(e, index)
                                    }
                                  />
                                )}
                              </div>

                              {selectedList.length > 1 ? (
                                <>
                                  {appointmentId && item.appt_id ? (
                                    <div
                                      className="col p1 fs-18 cursor-pointer"
                                      onClick={() =>
                                        this.deleteTreatment(index, item)
                                      }
                                    >
                                      <span className="icon-delete"></span>
                                    </div>
                                  ) : (
                                    <img
                                      width="25"
                                      height="25"
                                      onClick={() =>
                                        this.deleteTreatment(index, item)
                                      }
                                      className="ml-3"
                                      src={closeIcon}
                                      alt=""
                                    />
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                              {selectedList.length === index + 1 ? (
                                <>
                                  {" "}
                                  <div
                                    className="ml-3 cursor-pointer"
                                    onClick={() =>
                                      this.handleAddtreatment(index)
                                    }
                                  >
                                    <svg
                                      width="31"
                                      height="30"
                                      viewBox="0 0 31 30"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        width="31"
                                        height="30"
                                        fill="#F9F9F9"
                                      />
                                      <path
                                        d="M15 8V22"
                                        stroke="#848484"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M8 15H22"
                                        stroke="#848484"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="row selected text-center mb-4">
                          {t("No Data")}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <div className="d-flex">
            <div className="col-md-12">
              <div className="d-flex flex-wrap justify-content-end">
                <NormalButton
                  buttonClass={`p-2`}
                  resetbg={true}
                  className="col-12"
                  label="Cancel"
                  onClick={this.props.handleCloseDialog}
                />

                <NormalButton
                  buttonClass={`p-2`}
                  submitBtn={true}
                  label={appointmentId ? "Update" : "Confirm"}
                  // onClick={e => {
                  //   e.target.setAttribute("disabled", true);
                  //   this.handleUpdate();
                  // }}
                  onClick={_.debounce(async () => {
                    await this.handleSubmit();
                  }, 500)}
                />
              </div>
            </div>
          </div>
        </div>
        <NormalModal
          className={"multiple-appointment select-category"}
          style={{ minWidth: "60%" }}
          modal={isOpenModal}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close"
            src={closeIcon}
            alt=""
          />
          <div className="customer-list container">
            <div className="col-12 pl-0 mb-3 fw-500 py-2">
              <h5>{t("Select Treatment")}</h5>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  {t("Category")}
                  <NormalSelect
                    // placeholder="Enter here"
                    options={categoryList}
                    value={treatmentField.category}
                    name="category"
                    onChange={this.handleChangeTreatment}
                    className="customer-name p-0"
                  />
                </div>
                <div className="col-6">
                  {t("Service")}
                  <input
                    // placeholder="Enter here"
                    // options={siteList}
                    value={treatmentField.treatment}
                    name="treatment"
                    onChange={this.handleSearch}
                    className="search px-3 p-0"
                  />
                </div>
              </div>
            </div>

            <div className="table-container table-responsive mt-3">
              <TableWrapper
                headerDetails={treatmentListHeader}
                queryHandler={this.handlePagination}
                pageMeta={meta}
              >
                {treatmentList.length > 0 ? (
                  treatmentList.map((item, index) => {
                    return (
                      <tr
                        className="w-100"
                        onClick={() => this.handleSelectTreatment(item)}
                        key={index}
                      >
                        <td>
                          {" "}
                          <div className="text-left">{item.Item_Class}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-left">{item.item_desc}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-right">{item.add_duration}</div>
                        </td>
                        <td>
                          {" "}
                          <div className="text-right">{item.item_price}</div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <td colSpan="12">
                    <div className="d-flex align-items-center justify-content-center">
                      {t("No data Available")}
                    </div>
                  </td>
                )}
              </TableWrapper>
            </div>

            <div className="row text-center justify-center w-100">
              <NormalButton
                buttonClass={"col-3"}
                resetbg={true}
                className="col-12 ml-4"
                label="Cancel"
                onClick={this.handleDialog}
              />
            </div>
          </div>
        </NormalModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customerDetail: state.appointment.customerDetail,
  appointmentDetail: state.appointment.appointmentDetail,
  selectedTreatmentList: state.appointment.selectedTreatmentList,
  basicApptDetail: state.appointment.basicApptDetail,
  appointmentCustomerDetail: state.appointment.appointmentCustomerDetail,
  appointmentTreatmentList: state.appointment.appointmentTreatmentList,
  AppointmentCopy: state.appointment.AppointmentCopy,
  // Added by Santhosh
  siteId: state.appointment.getSiteId,
  tokenDetail: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateForm,
      getSelectedTreatmentList,
      getCommonApi,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
      commonUpdateApi,
    },
    dispatch
  );
};

export const StudioATreatment = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(StudioATreatmentClass)
);
